import { Content } from '../../types';

export const bangkachaoContent: Content = {
  title: "בנגקצ'או (Bangkachao) - הריאה הירוקה של בנגקוק",
  imageUrl: '/images/thailand/bangkachao/bangkachao-wide.jpeg',
  introduction: `בלב המטרופולין הסואן של בנגקוק, במרחק קצר מצומת סוקומוויט-אסוק, מסתתר אי ירוק, שליו ומרגיע - בנגקצ'או (Bangkachao).
האי נוצר כתוצאה מפיתוליו של נהר הצ'או פראייה ועקב אופיו הייחודי והירוק הוא מכונה "הריאה הירוקה של בנגקוק".
מבחינה מנהלית, משתייך האי למחוז סמוט פראקן (Samut Prakan), אך בפועל הינו חלק בלתי נפרד מהנוף העירוני של בנגקוק ומהווה מקום מפלט מההמולה.`,
  sections: [
    {
      title: "דרכי הגעה לבנגקצ'או",
      type: 'sub-headers',
      description: 'ישנן מספר דרכים להגיע לאי הירוק:',
      content: [
        {
          subtitle: 'ברכב',
          text: 'ניתן להגיע דרך מחוז סמוט פראקן, אך הדרך הפשוטה והמומלצת יותר הינה באמצעות מעבורת.',
        },
        {
          subtitle: 'במעבורת',
          text: "נסיעה קצרה של כ- 10 דקות ממרכז בנגקוק לרציף קלונג טואי (Klong Toei Pier), הנמצא ליד מקדש Wat Klong Toei Nok ומשם, חציית הנהר צ'או פראייה בסירה מקומית קטנה (Longtail Boat) בעלות של 20 באט לכיוון.",
        },
        {
          subtitle: 'חווית ההגעה',
          text: 'ברגע שתעברו את הנהר, תרגישו כאילו נכנסתם לעולם אחר - מבוך של שבילים ירוקים, תעלות מים ואווירה כפרית ייחודית.',
        },
      ],
    },
    {
      title: "מה לעשות בבנגקצ'או?",
      type: 'sub-headers',
      description: 'האי מציע מגוון פעילויות מהנות:',
      content: [
        {
          subtitle: 'טיול אופניים',
          text: 'הדרך הטובה ביותר לחוות את האי, הינה באמצעות אופניים. עם ההגעה, תוכלו לשכור אופניים בעלות של 100 באט ליום ולשוטט בין שבילים מתפתלים, גשרים קטנים, כפרים מסורתיים ותעלות מים ציוריות.',
        },
        {
          subtitle: 'פארק סרי נאחון קואן קאן (Sri Nakhon Khuean Khan Park)',
          text: 'לבו הפועם של האי, הינו הפארק האקולוגי היפהפה הזה, הכולל:\n<br />✔ שבילים ירוקים המתאימים להליכה ורכיבה על אופניים.\n<br />✔ אגמים עם בתי עץ וגשרים ציוריים.\n<br />✔ גן בוטני עם מגוון עשיר של צמחים.\n<br />✔ תצפיות על חיות בר, כולל ציפורים נדירות.',
        },
        {
          subtitle:
            'שוק צף בסופי שבוע - באנג נאם פונג (Bang Namphueng Floating Market)',
          text: 'במידה ותגיעו בשבת או בראשון, אל תפספסו את השוק הצף המקומי, בו תמצאו:<br />✔ דוכני אוכל תאילנדי מסורתי.<br />✔ מוצרי אומנות ועבודות יד.<br />✔ חוויות אותנטיות של קניות על המים.<br />✔ בתי קפה ומסעדות על הנהר',
        },
        {
          subtitle: 'בתי קפה עם נוף',
          text: "במהלך הטיול תוכלו לעצור בבתי קפה קסומים עם נוף לנהר, כדוג' Bangkok Tree House, המציע אווירה מיוחדת ואוכל מקומי מעולה.",
        },
      ],
    },
    {
      title: "מדוע להגיע לבנגקצ'או?",
      type: 'sub-headers',
      description: 'הנה מספר סיבות משכנעות לביקור באי:',
      content: [
        {
          subtitle: 'חוויה אותנטית',
          text: 'חוויה אותנטית ורגועה מחוץ לבנגקוק הסואנת.',
        },
        {
          subtitle: 'טבע בלב העיר',
          text: 'אוויר נקי וטבע ירוק בשטח שלא נפגע מהפיתוח העירוני.',
        },
        {
          subtitle: 'יעד לטיול יומי',
          text: 'יעד מושלם לטיול יומי הכולל רכיבה על אופניים, טבע ואוכל מקומי.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      content:
        "במידה והינכם מחפשים מפלט ירוק בתוך העיר - בנגקצ'או הינו המקום המושלם להירגע ולהתחבר לטבע.",
      type: 'text',
      isBold: true,
    },
  ],
};
